// Orden en que se leen las líneas de negocio en MRR Resumen y en el modal de metas.
// El backend las devuelve en orden alfabético (el del catálogo `lineas-negocio`).
export const LINEA_ORDER = [
  'B2B Asistencias',
  'B2B Employee Benefit Directo',
  'B2B Employee Benefit Brokers',
  'B2B2C',
  'B2C Directo',
  'B2C Brokers',
  'TPA'
];

const rank = (linea) => {
  const index = LINEA_ORDER.indexOf(linea);
  return index === -1 ? LINEA_ORDER.length : index;
};

/**
 * Ordena las líneas según LINEA_ORDER. Una línea nueva que no está en la lista va al
 * final, en orden alfabético, para que aparezca aunque nadie la haya ubicado todavía.
 */
export const sortLineas = (lineas) =>
  [...lineas].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
